import { datadogLogs } from '@datadog/browser-logs';
import { Cloud, FareStatus } from '@silbo/core';
import { useMutation } from '@tanstack/react-query';
import { useWithDurationLog } from '../../../../hooks/useWithDurationLog';

export const useFareTickMutation = ({
  onSuccess,
  onError,
}: {
  onSuccess: (data: unknown, variables: unknown, context: unknown) => void;
  onError?: (err?: unknown, variables?: unknown) => void;
}) => {
  const { mutateAsync, isPending, error, isError, isSuccess, reset } = useMutation({
    mutationFn: async ({ fareId, status }: { fareId: string; status: FareStatus | undefined }) => {
      datadogLogs.logger.debug('TANSTACK_DEBUG: TanStack Query executing fareTick mutation', {
        fareId,
        status,
        timestamp: Date.now(),
        source: 'tanstack-query',
      });
      await Cloud.fareTick({ fareId, status });
    },
    onError: (err, variables) => {
      datadogLogs.logger.error('TANSTACK_DEBUG: TanStack Query fareTick failed', {
        fareId: variables?.fareId,
        status: variables?.status,
        error: err,
        errorMessage: err instanceof Error ? err.message : 'Unknown error',
        timestamp: Date.now(),
        source: 'tanstack-query',
      });
      if (onError) {
        onError(err, variables);
      }
      datadogLogs.logger.error('fare-tick-error', err);
    },
    onSuccess,
    networkMode: 'online',
  });

  const fareTick = useWithDurationLog(mutateAsync, 'fare-tick-duration');

  return {
    fareTick,
    isPending,
    error,
    isError,
    isSuccess,
    reset,
  };
};
